/*
 * @Descripttion:
 * @Author: yang chenglin
 */
/**
 * 段落标题格式化组件
 * @param title  主标题(必选)
 * @param preface 序号(必选)
 */
import React from 'react';
import styles from './index.module.scss';

const SectionTitle = ({ title, preface }: { title: string; preface: string }): JSX.Element => {
  return (
    <section>
      <div className={styles.mainBox}>
        <div className={styles.preface}>{preface}</div>
        <div className={styles.title}>{title}</div>
      </div>
    </section>
  );
};
export default SectionTitle;
